import type { BiDashboardOut, BiMetricOut } from '@repo/api-codegen';
import { makeAutoObservable } from 'mobx';
import type { IUser, IWorkspace } from '../../api';
import { BIMetricStore } from '../BiMetric/store';

export class BIDashboardStore {
	id: string;
	private metricStoresCache: Map<string, BIMetricStore> = new Map();
	private user?: IUser;
	private workspace?: IWorkspace | null;

	constructor({
		dashboard,
		user,
		workspace,
	}: {
		dashboard: BiDashboardOut;
		user?: IUser;
		workspace?: IWorkspace | null;
	}) {
		this.id = dashboard.id;
		this.user = user;
		this.workspace = workspace;

		makeAutoObservable(this);
	}

	getOrCreateMetricStore = (
		metricId: string,
		metric: BiMetricOut
	): BIMetricStore => {
		if (!this.metricStoresCache.has(metricId)) {
			this.metricStoresCache.set(
				metricId,
				new BIMetricStore({
					metric,
					initialMode: 'chart',
					editable: false,
					user: this.user,
					workspace: this.workspace,
					isInDashboard: true,
				})
			);
		}
		return this.metricStoresCache.get(metricId)!;
	};

	refreshAllMetrics = async () => {
		const promises = Array.from(this.metricStoresCache.values()).map((store) =>
			store.refresh()
		);
		await Promise.all(promises);
	};

	get isRefreshingAny() {
		return Array.from(this.metricStoresCache.values()).some(
			(store) => store.isRefreshing
		);
	}

	dispose = () => {
		this.metricStoresCache.clear();
	};
}
